import { ItemKind } from '../../../constants/ItemKind';
import { MediaType } from '../../../constants/MediaType';
export function toFolder(data) {
  return {
    id: data.folderid,
    name: data.name,
    kind: ItemKind.Folder,
    source: 'deviantArt',
    mediaType: MediaType.Picture,
    parentId: data.parent,
    filesCount: 1,
    createdAt: null
  };
}